<template>
  <div></div>
</template>

<script>
import AzureAuthService from "@/services/AzureAuthService";
export default {
  name: "LoginAdSuccessView",

  data() {
    return {};
  },
  mounted() {
    AzureAuthService.loggedIn();
  }
};
</script>

<style scoped lang="scss"></style>
